export default {
  default: {
    title: 'A little about us',
    body: 'At NerdWallet, we offer straightforward advice and tools to help you make the best possible financial decisions. All for free.\n\nSo how do we make money? In most cases, when someone applies or gets approved for a financial product we get paid. But that doesn’t sway our opinions.',
  },
  investing: {
    title: 'A little about us',
    body: 'At NerdWallet, we offer straightforward info and tools to help you make the best possible financial decisions. All for free.\n\nSo how do we make money? In most cases, when someone applies or gets approved for a financial product we get paid. But that doesn’t sway our opinions.',
  },
  marketplace: {
    title: 'A little about us',
    body: 'At NerdWallet, we offer straightforward info and tools to help you make the best possible financial decisions. All for free.\n\nSo how do we make money? In most cases, when someone applies or gets approved for a financial product we get paid. But that doesn’t sway our opinions.',
  },
};
